module.exports = __webpack_public_path__ + "img/resource.83c59c46.png";